<template>
<div class="lists pl-0 py-1 " >
<div class="box-left " align="left">
   <p class="contatto m-0"> {{segnalazione.viewServizio.nome }} </p>
 <p class="tronco" @click.prevent="selezionato()" v-if="selected!==segnalazione.id">
   <u>{{ tronco }}<span v-if="tronco.length>=40">...</span> </u>
    </p>

  <div @click.prevent="selezionato()" v-if="selected===segnalazione.id">
     <p class="mr-3" >  {{ segnalazione.contenuto }}</p>

      <i >  {{segnalazione.nominativo }} </i>

</div>
      <small >- {{ convertToUtc(date)}} - </small>

      </div>
 <div class="row box-right align-self-end  mb-2">
    <button class="botton-secondary d-inline mt-0"  v-if="selected===segnalazione.id" @click="openOverlay()">modifica</button>
  <v-tooltip class="d-inline " top>
        <template v-slot:activator="{ on }">
          <div v-on="on">
              <span class="item-dot m-1" :stato="status" id="item-dot" ></span>
          </div>
        </template>
        <span class="textd" :stato="status"> </span>
      </v-tooltip>
</div>
<!-- TODO fix versione mobile adaptation -->
</div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'card-segnalazione',
  props: {
    segnalazione: Object,
    selected: Number
  },
  data () {
    return {
      date: this.segnalazione.lastUpdate,
      status: this.segnalazione.stato,
      tronco: this.segnalazione.contenuto.slice(0, 40)

    }
  },

  methods: {
    convertToUtc (date) {
      return moment(this.segnalazione.lastUpdate).utc().format('DD/MM/YYYY HH:MM')
    },
    selezionato () {
      this.$emit('sel')
    },
    openOverlay () {
      this.$emit('overl')
    }

  },
  watch: {
    selected: function (NewValue, OldValue) {
      // console.log('OLD -->', OldValue)
      // console.log('NEW -->', NewValue)
      // if (NewComune) {
      //   this.caricaSegnalazioni(NewComune).then(risultato => {
      //     console.log(risultato)
      //     this.segnalazioni = risultato
      //   })
      // }
    }
  }
}
</script>
